import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withModifiers as _withModifiers, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-49dc0658"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "pwd-popover-body" }
const _hoisted_2 = { class: "pwd-popover-text-row" }
const _hoisted_3 = ["title"]
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"margin-left":"auto"} }, [
  /*#__PURE__*/_createElementVNode("svg", {
    t: "1778297856172",
    class: "icon",
    viewBox: "0 0 1024 1024",
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": "9007",
    width: "25",
    height: "25"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      d: "M536 480v192a16 16 0 0 1-16 16h-16a16 16 0 0 1-16-16V480a16 16 0 0 1 16-16h16a16 16 0 0 1 16 16z m-32-128h16a16 16 0 0 1 16 16v32a16 16 0 0 1-16 16h-16a16 16 0 0 1-16-16v-32a16 16 0 0 1 16-16z m8 448c159.056 0 288-128.944 288-288s-128.944-288-288-288-288 128.944-288 288 128.944 288 288 288z m0 48c-185.568 0-336-150.432-336-336s150.432-336 336-336 336 150.432 336 336-150.432 336-336 336z",
      style: {"fill":"var(--cm-color-text-secondary)"},
      "p-id": "9008"
    })
  ])
], -1))
const _hoisted_5 = { class: "pwd-popover-actions cm-ui-mt16" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  t: "1778296601350",
  class: "icon pwd-action-icon",
  viewBox: "0 0 1024 1024",
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg",
  "p-id": "6947",
  width: "16",
  height: "16"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M792.64 96h-320a136.96 136.96 0 0 0-136.96 136.96v103.04H231.36A136.96 136.96 0 0 0 96 471.36v320a136.96 136.96 0 0 0 136.96 136.96h320a136.96 136.96 0 0 0 136.96-136.96v-101.76h103.04a136.96 136.96 0 0 0 136.96-136.96v-320A136.96 136.96 0 0 0 792.64 96zM608 792.64a53.76 53.76 0 0 1-53.76 53.76h-320a53.76 53.76 0 0 1-53.76-53.76v-320a53.76 53.76 0 0 1 53.76-53.76h320A53.76 53.76 0 0 1 608 471.36z m240-240A53.76 53.76 0 0 1 792.64 608h-103.04v-136.64a136.96 136.96 0 0 0-136.96-136.96h-135.04V231.36a53.76 53.76 0 0 1 53.76-53.76h320a53.76 53.76 0 0 1 53.76 53.76z",
    "p-id": "6948",
    fill: "#fff"
  })
], -1))
const _hoisted_7 = {
  key: 0,
  class: "pwd-action-icon el-icon-view",
  "aria-hidden": "true"
}
const _hoisted_8 = {
  key: 1,
  t: "1778296713616",
  class: "icon",
  viewBox: "0 0 1024 1024",
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg",
  "p-id": "7951",
  width: "16",
  height: "15"
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  d: "M950.9 393.3c-25.24-34.07-60.9-64.39-105.9-90.11C755.5 252.12 637.26 224 512 224a805.82 805.82 0 0 0-116.25 8.33 32 32 0 0 0 9.25 63.33A742 742 0 0 1 512 288c114.3 0 221.28 25.13 301.22 70.77C887.51 401.18 928.43 455.6 928.43 512s-40.77 110.62-114.81 153a32 32 0 1 0 31.8 55.54c44.92-25.71 80.46-56 105.62-90 27.46-37.14 41.39-77 41.39-118.51S978.46 430.5 950.9 393.3z",
  "p-id": "7952",
  fill: "var(--el-color-primary)"
}, null, -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  d: "M666.66 564.2a31.27 31.27 0 0 0 4.08 0.26 32 32 0 0 0 31.71-28A194.58 194.58 0 0 0 704 512c0-105.87-86.13-192-192-192a195.21 195.21 0 0 0-26.39 1.8 32 32 0 0 0 8.73 63.41A129.9 129.9 0 0 1 512 384a128.14 128.14 0 0 1 128 128 129.93 129.93 0 0 1-1 16.41 32 32 0 0 0 27.66 35.79zM760.18 715.05a32.32 32.32 0 0 0-6.35-6.34l-332.58-332.3-108.89-108.79-0.1-0.1-161-160.84A32 32 0 1 0 106.05 152L231.5 277.3c-51.13 21.8-94.76 49.51-127.87 81.44C56.49 404.2 31.57 457.2 31.57 512c0 41.57 14 81.5 41.53 118.7 25.24 34.07 60.89 64.39 106 90.11C268.5 771.88 386.75 800 512 800c74.2 0 147.47-10.12 213.28-29.34l148.3 148.18a32 32 0 1 0 45.24-45.28zM401.56 447.21l175.32 175.18a128.07 128.07 0 0 1-175.32-175.18zM512 736c-114.3 0-221.28-25.13-301.22-70.77C136.49 622.82 95.57 568.4 95.57 512c0-73.36 70.46-143.37 185.24-185.44L355.3 401A190.64 190.64 0 0 0 320 512c0 105.87 86.13 192 192 192a190.58 190.58 0 0 0 111.14-35.39l49.66 49.61C622.07 729.91 567.39 736 512 736z",
  "p-id": "7953",
  fill: "var(--el-color-primary)"
}, null, -1))
const _hoisted_11 = [
  _hoisted_9,
  _hoisted_10
]

import { computed, ref } from 'vue'
import { useI18n } from 'vue-i18n'
import { copyText } from '@/utils/tool'


export default /*#__PURE__*/_defineComponent({
  __name: 'remote-auth-policy-password-link',
  props: {
    password: {},
    loadPassword: { type: Function }
  },
  setup(__props: any) {

const props = __props

const { t } = useI18n()
const passwordVisible = ref(false)
const fetchedPlain = ref('')
const loading = ref(false)
const loadAttempted = ref(false)

const plain = computed(() => (props.password ?? fetchedPlain.value ?? '').trim())

const displayText = computed(() => {
  if (loading.value) return t('remoteAuth.loading')
  if (!plain.value) return t('remoteAuth.passwordNotAvailable')
  return passwordVisible.value ? plain.value : '••••••••'
})

async function ensurePasswordLoaded() {
  if (loadAttempted.value || loading.value) return
  const hasInline = (props.password ?? '').trim().length > 0
  if (hasInline) {
    loadAttempted.value = true
    return
  }
  if (!props.loadPassword) {
    loadAttempted.value = true
    return
  }
  loading.value = true
  try {
    fetchedPlain.value = (await props.loadPassword()).trim()
  } finally {
    loading.value = false
    loadAttempted.value = true
  }
}

function onPopoverHide() {
  passwordVisible.value = false
}

function onCopy() {
  if (!plain.value) return
  copyText(plain.value)
}

return (_ctx: any,_cache: any) => {
  const _component_el_link = _resolveComponent("el-link")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_popover = _resolveComponent("el-popover")!

  return (_openBlock(), _createBlock(_component_el_popover, {
    trigger: "hover",
    "show-after": 200,
    width: 230,
    placement: "top",
    teleported: true,
    "show-arrow": true,
    "popper-class": "remote-auth-pwd-popper",
    onHide: onPopoverHide
  }, {
    reference: _withCtx(() => [
      _createVNode(_component_el_link, {
        type: "primary",
        underline: false,
        size: "small",
        onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["prevent"])),
        onMouseenter: ensurePasswordLoaded,
        onFocus: ensurePasswordLoaded
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(t)('remoteAuth.showPasswordLink')), 1)
        ]),
        _: 1
      })
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", {
            class: "pwd-popover-text",
            title: passwordVisible.value ? plain.value : ''
          }, _toDisplayString(displayText.value), 9, _hoisted_3),
          _createVNode(_component_el_tooltip, {
            content: _unref(t)('remoteAuth.authPasswordOptionSubtitle'),
            placement: "top"
          }, {
            default: _withCtx(() => [
              _hoisted_4
            ]),
            _: 1
          }, 8, ["content"])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_el_tooltip, {
            content: _unref(t)('rawDataDrawer.copy'),
            placement: "top"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_button, {
                type: "primary",
                size: "small",
                class: "pwd-icon-btn",
                disabled: !plain.value || loading.value,
                onClick: onCopy
              }, {
                default: _withCtx(() => [
                  _hoisted_6
                ]),
                _: 1
              }, 8, ["disabled"])
            ]),
            _: 1
          }, 8, ["content"]),
          _createVNode(_component_el_tooltip, {
            content: passwordVisible.value ? _unref(t)('remoteAuth.passwordHide') : _unref(t)('remoteAuth.passwordReveal'),
            placement: "top"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_button, {
                type: "primary",
                size: "small",
                plain: "",
                class: "pwd-icon-btn",
                disabled: !plain.value || loading.value,
                onClick: _cache[1] || (_cache[1] = ($event: any) => (passwordVisible.value = !passwordVisible.value))
              }, {
                default: _withCtx(() => [
                  (!passwordVisible.value)
                    ? (_openBlock(), _createElementBlock("i", _hoisted_7))
                    : (_openBlock(), _createElementBlock("svg", _hoisted_8, _hoisted_11))
                ]),
                _: 1
              }, 8, ["disabled"])
            ]),
            _: 1
          }, 8, ["content"])
        ])
      ])
    ]),
    _: 1
  }))
}
}

})